// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1656":"css/admin-app.7051","7597":"css/app.7051"}[chunkId] + ".css";
};